"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETipoQuestPergunta = void 0;
var ETipoQuestPergunta;
(function (ETipoQuestPergunta) {
    ETipoQuestPergunta[ETipoQuestPergunta["Discursiva"] = 1] = "Discursiva";
    ETipoQuestPergunta[ETipoQuestPergunta["Multipla Escolha"] = 2] = "Multipla Escolha";
    ETipoQuestPergunta[ETipoQuestPergunta["Objetiva"] = 3] = "Objetiva";
    ETipoQuestPergunta[ETipoQuestPergunta["Men\u00E7\u00F5es"] = 4] = "Men\u00E7\u00F5es";
    ETipoQuestPergunta[ETipoQuestPergunta["Atitudes"] = 5] = "Atitudes";
})(ETipoQuestPergunta = exports.ETipoQuestPergunta || (exports.ETipoQuestPergunta = {}));
